import { Controller } from "@hotwired/stimulus"

// Копирование строки в буфер (ссылки шаблонов в админке). Отдельно от
// share_controller: тому нужны оба таргета — «Отправить…» и «Скопировать», —
// и без системного меню он не поднимается.
export default class extends Controller {
  static targets = ["button"]
  static values = {
    text: String,
    copiedLabel: { type: String, default: "Скопировано" }
  }

  disconnect() {
    clearTimeout(this.restoreTimer)
  }

  async copy() {
    let copied = false
    try {
      await navigator.clipboard.writeText(this.textValue)
      copied = true
    } catch {
      copied = this.copyByExecCommand(this.textValue)
    }

    if (copied) this.flash()
  }

  // Clipboard API живёт только в secure context (https/localhost) — на остальных
  // остаётся старый способ через скрытую textarea.
  copyByExecCommand(text) {
    const area = document.createElement("textarea")
    area.value = text
    area.setAttribute("readonly", "")
    area.style.position = "fixed"
    area.style.top = "-1000px"
    document.body.appendChild(area)
    area.select()

    let copied = false
    try {
      copied = document.execCommand("copy")
    } catch {
      copied = false
    }
    document.body.removeChild(area)
    return copied
  }

  flash() {
    if (!this.hasButtonTarget) return

    const label = this.buttonTarget.textContent
    this.buttonTarget.textContent = this.copiedLabelValue
    this.restoreTimer = setTimeout(() => {
      this.buttonTarget.textContent = label
    }, 2000)
  }
}
